<template>
  <v-card style="padding:24px;border-top: 4px solid #f74e50;opacity: 0.91;">
    <v-btn icon @click="$emit('close')" style="position:absolute;top:0px;right:0px">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="title" style="margin-bottom:6px; font-weight: 600;">{{nav.title}}</div>
    <v-form ref="form" v-model="valid">
      <v-row :gutter="4" justify="center" style="margin:4px 0">
        <v-col cols="12" sm="12" md="12">
          <v-text-field label="联系方式（手机）" v-model="form.title" :rules="rule.title" :counter="18"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-textarea name="input-7-1" label="留言咨询" v-model="form.content" :rules="rule.content"></v-textarea>
        </v-col>
        <v-col cols="12" sm="12" md="5">
          <v-btn color="primary" block @click="submit">提 交</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="alterDialog" hide-overlay width="300">
      <v-card color="indigo darken-1" dark style="padding:16px;opacity: 0.72;">
        <h4 style="text-align: center;">
          <v-icon dark right>mdi-checkbox-marked-circle</v-icon>留言成功
        </h4>
      </v-card>
    </v-dialog>

    <!-- <v-snackbar v-model="snackbar" :multi-line="multiLine" top style="z-index:999">{{ text }}</v-snackbar> -->
  </v-card>
</template>

<script>
import { putSuggest } from "@/api/info";
export default {
  props: ["nav", "navData"],
  data: () => ({
    valid: true,
    multiLine: true,
    snackbar: true,
    alterDialog: false,
    text: "留言成功",
    form: { title: undefined, content: undefined },
    rule: {
      title: [
        v => !!v || "联系方式必填",
        v => (v && v.length <= 18) || "正确手机号？"
      ],
      content: [
        v => !!v || "内容必填",
        v => (v && v.length <= 360) || "最多360字"
      ]
    }
  }),
  watch: {
    navData: function(newNavData, oldNavData) {}
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        putSuggest(this.form).then(res => {
          this.alterDialog = true;
          setTimeout(() => {
            this.alterDialog = false;
          }, 1500);
          this.$emit("close");
        });
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
</style>
